<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增分组</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table"  @selection-change="SeleChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="group_name" label="分组名称" min-width="100" />
            <el-table-column prop="description" label="分组描述" min-width="150" />
            <el-table-column prop="expert_ids" label="分组成员" min-width="200">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap">
                        <el-tag v-for="item in scope.row.expert_ids" :key="item" type="success" size="small">
                            {{getUserByName(item)}}
                        </el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="100" />
            <el-table-column label="操作" min-width="140" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑" placement="top-start">                        <i class="NavIcon el-icon-edit" @click="ToggleDig(scope.row)"></i>                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">
                          <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page"
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增分组':'修改分组'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">分组名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入分组名称" v-model="NewData.group_name"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">分组成员：</div>
                <el-select class="Wid" size="medium" v-model="NewData.expert_ids" multiple placeholder="请选择组员">
                    <el-option v-for="item in UserList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">分组描述：</div>
                <el-input class="Wid" type="textarea" :rows="2" size="medium" placeholder="请输入分组描述" v-model="NewData.description"></el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "UserTable",
        data() {
            return {
                SearchVal:"",
                Data: [],
                SeleId:[],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                RowData:'',
                UserList:[],
                NewData:{
                    id:'',
                    NewBlon:false,
                    description:"",
                    group_name:"",
                    expert_ids:[],
                },
            };
        },
        mounted() {
            this.GetData();
            this.GetUser();
        },
        methods: {
            GetData(){
                this.$get('/admin/expert_group/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetUser(){
                this.$get('/admin/expert/index',{
                    page:1,
                    page_size:500,
                }).then(res=>{
                    if(res){
                        this.UserList = res.data.list;
                    }
                })
            },
            GetDetail(id){
                this.$get('/admin/expert_group/detail',{
                    id:id,
                }).then(res=>{
                    if(res){
                        this.RowData = res.data;
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.description = row.description;
                    this.NewData.group_name = row.group_name;
                    this.NewData.expert_ids = row.expert_ids;
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                this.SucData()
            },
            SucData(){
                var url = "/admin/expert_group/update"
                if(this.Type=='Add'){
                    url = '/admin/expert_group/save';
                }
                this.$post(url,this.NewData).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        if(this.Type!='Add'){
                            this.GetData();
                        }else{
                            this.ReSetPage();
                        }
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            SeleChange(val){
                this.SeleId = val.map(item => item.id);
            },
            Delete(id) {
                var Ids = id!=""?[id]:this.SeleId;
                this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/expert_group/delete',{
                        ids:Ids,
                    }).then(res=>{
                        if(res){
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            getUserByName(userId) {
                // 找到匹配的申请人
                const targetUser = this.UserList.find(item => item.id === userId);
                // 有匹配返回申请人名，无匹配返回"未知申请人"
                return targetUser?targetUser.name:"未知申请人";
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
